

import {AfterContentChecked , Directive, ElementRef, Input,} from '@angular/core';

@Directive({
  selector: 'input[appFocus]',
})
export class FocusDirective implements AfterContentChecked  {

  @Input('appFocus') isFocused: boolean;

  constructor(private element: ElementRef<HTMLInputElement>) {
  }

  ngAfterContentChecked (): void {
    if (this.isFocused) {
      this.element.nativeElement.focus();
    }
  }
}

